// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { store } from '@/store'
import { parseISO } from 'date-fns'
import { fetchWithTimeout } from '@/common/shared'
import { ehrCrudUrl } from '../../../settings'
import { showToast } from '../../../utils/utils'

const editReportFile = async (
  itemToEdit,
  eventDate,
  typeSelect,
  description,
  accessionNum,
  labName,
  specimenType,
) => {
  if (!itemToEdit.uuid) { return }
  // We currently have to make two calls to the API to update a report.
  // report-store/report/ can't be used to update identifiers.
  const basicUrl = `${ehrCrudUrl}/report-store/report/${itemToEdit?.uuid}`
  const identifiersUrl = `${ehrCrudUrl}/report-store/report-identifier/${itemToEdit?.uuid}`

  const headers = {
    'Authorization': 'Bearer ' + store.getters.jwt,
    accept: 'application/json, text/plain, */*',
    'content-type': 'application/json',
  }

  try {
    const fetchParams = {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify({
        'report_type': typeSelect,
        'mimetype': itemToEdit.mimetype,
        'description': description,
        'base64': itemToEdit.base64,
        'ordering_date': parseISO(eventDate).toISOString(),
      }),
    }

    const accessionResponse = await updateIdentifier(itemToEdit, 'accession_num', accessionNum, identifiersUrl, headers, showToast)
    if (!accessionResponse.ok) { return accessionResponse }

    const specimenResponse = await updateIdentifier(itemToEdit, 'specimen_type', specimenType, identifiersUrl, headers, showToast)
    if (!specimenResponse.ok) { return specimenResponse }

    const labNameResponse = await updateIdentifier(itemToEdit, 'lab_name', labName, identifiersUrl, headers, showToast)
    if (!labNameResponse.ok) { return labNameResponse }

    const response = await fetchWithTimeout(basicUrl, fetchParams)

    if (!response.ok) {
      showToast('error', `Error with network request: ${response.status}`)
    }

    showToast('success', `Successfully edited ${itemToEdit.description}`)

    return response
  } catch (e) {
    showToast('error', `Error with network request: ${e}`)
  }
}

const updateIdentifier = async (
  itemToEdit,
  identifier_type,
  identifier,
  identifiersUrl,
  headers,
  showToast,
) => {
  const fetchParams = {
    method: itemToEdit.identifiers.find((i) => i.identifier_type === identifier_type) ? 'PUT' : 'POST',
    headers: headers,
    body: JSON.stringify({
      identifier_type,
      identifier,
    }),
  }
  const response = await fetchWithTimeout(identifiersUrl, fetchParams)
  if (!response.ok) {
    showToast('error', `Error with network request: ${response}`)
  }
  return response
}


export default editReportFile
